import { render, staticRenderFns } from "./ChatFileV3.vue?vue&type=template&id=d67690c2&scoped=true"
import script from "./ChatFileV3.vue?vue&type=script&lang=js"
export * from "./ChatFileV3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67690c2",
  null
  
)

export default component.exports